import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint, duration } from '@twistopayments/design-system/styles';

export const root = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: ${theme.spacing[48]};
  padding: ${theme.spacing[8]} ${theme.spacing[16]};
  color: ${theme.palette.text.title};
  border-radius: ${theme.borderRadius.sm};
  background-color: ${theme.palette.tertiary.lowContrast};
  font-weight: 500;
  border: 2px solid transparent;
  margin: ${theme.spacing[8]} 0;
  transition:
    background-color ${duration.standard}ms,
    border-color ${duration.shorter}ms;

  ${breakpoint.up('sm')} {
    margin: ${theme.spacing[16]} 0;
  }

  &:hover {
    background: ${theme.palette.tertiary.mediumContrast};
  }

  &:focus {
    outline: 2px solid ${theme.palette.secondary.mediumContrast};
    outline-offset: 2px;
  }
`;

export const active = (theme: Theme) => css`
  border: 2px solid ${theme.palette.secondary.mainContrast};
  outline: 2px solid ${theme.palette.secondary.lowContrast};

  // in case the element is focused by click (not tab) use the default outline
  &:focus:not(:focus-visible) {
    outline-offset: 0;
  }
`;

export const disabled = (theme: Theme) => css`
  background-color: ${theme.palette.background.accent};
  color: ${theme.palette.ghost.mediumContrast};
  pointer-events: none;
`;

export const types = {
  /* Styles applied to the root element if `type="default"`. */
  default: css`
    cursor: default;
  `,
  /* Styles applied to the root element if `type="link"`. */
  link: css`
    cursor: pointer;
    text-decoration: none;
  `,
};

export const clickable = css`
  cursor: pointer;
`;
